import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import './formPopup.scss';
import  { IconType, IconSize } from '../../atoms/icon/icon';
import ModalBootstrap from 'react-bootstrap/Modal';
import { Form, ButtonGroup, ToggleButton } from 'react-bootstrap';
import FormGroup from '../../organisms/formGroup/formGroup2';
import FormPopupFooter from './formPopupFooter';
import { httpGet, httpPost, httpPut } from '../../../store/externalCalls/httpCalls';
import Toaste from '../../atoms/toast/toaste';
import { epochToDate } from '../../../utils/dateUtils';
import formStaticImage from '../../../config/components/formStaticImage';
import swal from 'sweetalert';
import UploadDragAndDrop from '../uploadDragAndDrop/uploadDragAndDrop';
import FormInputText from '../formInputText/formInputText';
import FormInputTypes from '../../atoms/formEnums/formInputTypes';
import highlightedContentIcon from '../../atoms/customIcons/highlightedContentIcon.svg';
import staticGraphicIcon from '../../atoms/customIcons/staticImageIcon.svg';
import sportRoomIcon from '../../atoms/customIcons/sportRoomIcon.svg';
import { GetImgNoImage, getLongSize } from '../../../utils/canvasUtils';

export const ModalSize = {
  LARGE: 'lg',
  SMALL: 'sm',
  XTRALARGE: 'xl',
  BLOCK:'block'
};
/**
 * Help button is a Button associate to popup paragraph with a help text.
 */
 let userEmail;

const FormPopup = (props) => {
  const {
    id,
    nextId,
    title,
    configFile,
    field,
    parent,
    value,
    show,
    onEditPopup,
    onNewPopup,
    onClosePopup,
    params,
    uniqueId,
    parentUID,
    mode,
    parentData,
    popupError,
    size,
    extraClassName,
    superTitle,
    icon,extraValues,
    viewSelection,
    viewSelectionType,
    viewSelectionUrl,
    viewSelectionId,
    viewSelectionParams,
    viewSelectionResultField,
    spaceName

  } = props;
  
  const [staticImageTitle,setStaticImageTitle] =useState("Add Static Image");
  const [staticImageConfig,setStaticImageConfig] =useState(formStaticImage);
  const [popupValuesStaticImage,setPopupValuesStaticImage] =useState([]);
  const [staticImageList,setStaticImageList] =useState([]);
  const [staticImageElement,setStaticImageElement] =useState({});
  const [showStaticImagePopup,setShowStaticImagePopup] =useState(false);
  const [typeMode,setTypeMode] =useState('1');
  const [enableDragAndDrop,setEnableDragAndDrop]=useState(true);
  const [imageDetail,setImageDetail] =useState(null);
  const typeModes = [
    { name: 'Highlighted Contents', value: '1' },
    { name: 'Add Static graphic', value: '2' },
  ];
  const [manualStaticGraphic,setManualStaticGraphic] =useState(null);
  const [backgroundGraphic,setBackgroundImage] =useState(null);
  const getDefaultValuesConfig=(nextId,uniqueId,parentUID)=>{
    let defaults={};
    if(configFile){
      configFile.forEach(formGroup=>{
        formGroup.fields.forEach(field=>{
          if(field.default)
            if(mode!="edit")
              defaults = {...defaults,...{[field.attributeName]:field.default}};
              if(extraValues){
                defaults = {...defaults,...extraValues};
              }
          else{
            defaults={};
          }
        });
      });
    }
    if(nextId>=0){
      defaults = {...defaults,...{nextId:nextId}};
    }
    if(uniqueId>0){
      defaults = {...defaults,...{uniqueId:uniqueId}};
    }
    if(parentUID>0){
      defaults = {...defaults,...{parentUID:parentUID}};
    }
    
    return defaults;
  }
  const [popupValues,setPopupValues] =useState(null);
  const [errors, setErrors] = useState({});
  useEffect(() => {
    setTypeMode('1');
    if(show==false) //"reset values of popup when exit the popup");
      setPopupValues({});
  }, [show]);
  
  useEffect(() => {
    if(mode=="edit"){
      cleanPopupValues();
      if(viewSelection){
        let field="";
        let params={};
        if(viewSelectionParams)
          params=viewSelectionParams;

        if(value && value.tableValue){
          if(value.tableValue.id){
            params[viewSelectionId]=value.tableValue.id;
          }else{
            params[viewSelectionId]=value.tableValue.ids;
            field=viewSelectionResultField;
          }
          if(value.backgroundImage){
            params.backgroundImage= value.backgroundImage;
          }
          httpPost(viewSelectionUrl,params).then((res)=>{
            if(field){
              value.tableValue=res[field];
            }else{
              value.tableValue=res;
            }
            setPopupValues({...popupValues,...value});
          });
        }
      }
        setPopupValues({...popupValues,...value,...extraValues});
    }else{
      let def=getDefaultValuesConfig(nextId,uniqueId,parentUID);
      setPopupValues({...def,...value});
    }
  }, [value]);
  
  useEffect(()=>{
    if(popupError!=null){
      const messages = popupError.errors;
      setErrors(messages);
      setTimeout(() => {
        setErrors({});
    }, 5000);
    }
  },[popupError]);
  const cleanPopupValues=()=>{
    let emptyValues=popupValues;
    Object.keys(emptyValues).forEach((el)=>{
      emptyValues[el]='';
    });
    setPopupValues(emptyValues);
  }
  const handleClose = (e) => {
    cleanPopupValues();
    onClosePopup(null)
  };
  
  const validatePopup=(validationUrl,attributePopup,parentData=null,mode)=>{
    var promise = new Promise( (resolve, reject) => {
      let editId;
      let location=window.location.pathname;
      let locationArr = location.split("/");
      if(locationArr[locationArr.length-1]!="new")
        editId=locationArr[locationArr.length-1];
      
      let params={'values':popupValues,'popup':attributePopup,'parentData':parentData,"mode":mode};
      if(validationUrl){
        if(editId){
          validationUrl+="/"+editId;
          httpPut(validationUrl, params).then((res)=>{
            resolve(res);
          }).catch(error=>{
            reject(error);
          });
        }else{
          httpPost(validationUrl, params).then((res)=>{
            resolve(res);
          }).catch(error=>{
            reject(error);
          });
        }
      }else{
        resolve(true);
      }
    });
    return promise;
  }

  const handleEdit=(e)=>{
    validatePopup(configFile[0].validationUrl,configFile[0].attributeName,null,"edit").then((res)=>{
      if(Object.keys(res).length>0)
        onEditPopup(e,field,{...res},id,parent);
      else
        onEditPopup(e,field,{...popupValues},id,parent);
    }).catch(error=>{
            const messages = error.errors;
      setErrors(messages);
      setTimeout(() => {
        setErrors({});
    }, 5000);
    });
  }

  const handleSave=(e)=>{
    if(configFile[0].validationUrl){
      validatePopup(configFile[0].validationUrl,configFile[0].attributeName,parentData,"save").then((res)=>{
        if(res!=null){
          let newValues={...popupValues,...res};
          onNewPopup(e,field,{...newValues},null,parent);
        }
        else
          onNewPopup(e,field,{...popupValues},null,parent);
      }).catch(error=>{
        const messages = error.errors;
        setErrors(messages);
        setTimeout(() => {
          setErrors({});
      }, 5000);
      });
    }else{
      onNewPopup(e,field,{...popupValues},null,parent);
    }
  }

  const handlerOnChange=(valueChanged)=>{
    setPopupValues({...popupValues,...valueChanged});
    if(valueChanged.gridButtons){
      onClosePopup(valueChanged.gridButtons);
    }
  }

  const handlerOnChangeStaticImage=(valueChanged)=>{
    let obj={};
    httpGet("downloadableUrl/"+valueChanged.urlId).then((res)=>{
      obj={id:valueChanged.urlId,contentType:"staticImage",url:res};
      setPopupValuesStaticImage(obj);
    }).catch(error=>{
      console.log("error");
    });
  }
  
  function insertElementBeforeReference(array, newElement, referenceElement) {
    // Find the index of the reference element
    const index = array.findIndex(element => element === referenceElement);
    // If the reference element is found, insert the new element before it
    if (index > -1) {
        array.splice(index, 0, newElement);
    }
    // Return the modified array
    return array;
}
  const getUniqueId=()=>{
    return Math.round(Math.random()*100000000000+100000000000);
  }
  const getTopBottomIndex=(index,el,arr)=>{
    return <div className="number-list">
    <div className="buttons-flex-column">
      <div> 
        <Button
          id={"up"}
          className="float-right"
          type={"button"}
          onClick={() => upElement(el,arr)}
          icon={IconType.ARROW_UP}
          iconSize={IconSize.LARGE}
          iconColor={"#000000"}
          title="Move element up"
        >
        </Button>
      </div>
      <div>{index+1}</div>
      <div> 
        <Button
          id={"down"}
          className="float-right"
          type={"button"}
          onClick={() => downElement(el,arr)}
          icon={IconType.ARROW_DOWN}
          iconSize={IconSize.LARGE}
          iconColor={"#000000"}
          title="Move element down"
        >
        </Button>
      </div>
    </div>
  </div>;
  }
  const getRowType=(type,text,el=null,arr=null)=>{
    let icon=null;
    switch(type){
      case "higlighted":
        icon=highlightedContentIcon;
      break;
      case "staticGraphic":
        icon=staticGraphicIcon;
      break;
      case "SportRoom":
        icon=sportRoomIcon;
      break;
    }
    return <div className="rowTypeMain">
    <div className={"rowType rowType--"+type}>
      <img className="icon" src={highlightedContentIcon} /><span className="text">{text}</span>
    </div>
    {el && arr &&
    <div className="rowButton">
      <Button
          id={"remove"}
          className="float-right"
          type={"button"}
          onClick={() => removeElement(el,arr)}
          icon={IconType.DELETE}
          iconSize={IconSize.LARGE}
          iconColor={"#000000"}
        >
      </Button>  
    </div>}
  </div>
  }
  const getSingleTableValue=(value,type)=>{
    let image=null;
    let noImage=null;
    let size=getLongSize(viewSelectionParams.size);
    if(type=="highlightedContent" || type=="highlighted"){
      if(value && value[size+"_url"]){
        image=value[size+"_url"]["url"];
    }
      if(image==null){
        noImage=GetImgNoImage(viewSelectionParams.size,null);
    }
  }else if(type=="sportRoom"){
      if(value && value[size+"_url"] && value[size+"_url"]["url"]){
        image=value[size+"_url"]["url"];
      }else{
        if(value && value[size+"_url"]){
          image=value[size+"_url"];
        }else
          noImage=GetImgNoImage(viewSelectionParams.size,null);
  }
    }else{
      image="no-image.jpg";
    }
    return <div className="content-row">
      <div className="column-image">
        {(type=="highlighted" || type=="highlightedContent") && <img src={image?image:noImage}/>}
        {type =="sportRoom" && <img src={image?image:noImage}/>}
      </div>
      <div>
        <div>
          <div className="field-label">Canvas size:</div><div className="field-value"> {viewSelectionParams.size}</div>
        </div>
          <div>
          <div className="field-label">Name:</div><div className="field-value"> {value.name}</div>
          </div>
          <div>
          <div className="field-label"><b>Space:</b></div><div className="field-value"> <b>{value.app?.name ?? value.app}</b></div>
          </div>

        {value.activationEpoch && <div>
            <div className="field-label">Is Live:</div><div className="field-value"> {value.isLive?"Yes":"No"}</div>
        </div>}
        {value.activationEpoch && <div><div className="field-label">Activation time:</div><div className="field-value"> {epochToDate(value.activationEpoch)}</div></div>}
        {value.isLive && <div><div className="field-label">Starting time:</div><div className="field-value"> {epochToDate(value.startEpoch)}</div></div>}

        {value.expirationEpoch && <div><div className="field-label">Expiration time:</div><div className="field-value"> {epochToDate(value.expirationEpoch)}</div></div>}
        {value.duration && <div><div className="field-label">Duration:</div><div className="field-value"> {value.duration}</div></div>}
        {value.visibility && <div><div className="field-label">Visibility:</div><div className={"field-value "+(value.visibility=="hidden"?"field-red":"")}> {value.visibility}</div></div>}
        
      </div>
    </div>
  
}
  // const addStaticImage=(el,list)=>{
  //   console.log("click",el,list);
  //   setStaticImageList(list);
  //   setStaticImageElement(el);
  //   setShowStaticImagePopup(true);
  // }

  const handleCloseStaticImage=()=>{
    console.log("close");
    setShowStaticImagePopup(false);
  }
  const handleEditStaticImage=()=>{
    let newTableValues=popupValues.tableValue;
    let result=insertElementBeforeReference(newTableValues,popupValuesStaticImage,staticImageElement);
    handlerOnChange({tableValue:newTableValues});
    setShowStaticImagePopup(false);
  }
  const handleSaveStaticImage=()=>{
    let newTableValues=popupValues.tableValue;
    insertElementBeforeReference(newTableValues,popupValuesStaticImage,staticImageElement);
    handlerOnChange({tableValue:newTableValues});
    setShowStaticImagePopup(false);
  }

  const removeElement=(el,list)=>{
    swal({
      title: 'Are you sure?',
      text: "You are about to remove an element from the selected list",
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((ok) => {
      if (ok) {
        let test=popupValues;
        test.tableValue=[];
        
        let newTableValues = list.filter((element, index) =>{
          if(element.type!=el.type || element.id!=el.id){
            return element;
          }
        });
        handlerOnChange({tableValue:newTableValues});
      }
    });
    
  }

  const upElement=(el,list)=>{
    // Find the index of the element
    const index = list.findIndex(element => element === el);
    // console.log(index);
    // Check if the element is found and is not already at the first position
    if (index > 0) {
        // Swap the element with the one before it
        const temp = list[index - 1];
        list[index - 1] = list[index];
        list[index] = temp;
    }

    handlerOnChange({tableValue:list});
  }

  const downElement=(el,list)=>{
    const index = list.findIndex(element => element === el);
    // Check if the element is found and is not already at the last position
    if (index > -1 && index < list.length - 1) {
        // Swap the element with the one after it
        const temp = list[index + 1];
        list[index + 1] = list[index];
        list[index] = temp;
    }
    handlerOnChange({tableValue:list});
  }

  const getArrayTableValues=(arr)=>{
    return(<div className="list">
      {arr.map((el,index)=>{
        switch(true){
          case (el.contentType=="category" || el.hasOwnProperty("allVideos")):
              return <div key={index}>
                  <div key={index} className="box2 bcolor-grey ordered-list">
                    {getTopBottomIndex(index,el,arr)}
                    <div className="padding-10" style={{flex:1}}>
                    {getRowType("category","Content Category",el,arr)}
                      <div className="padding-10">
                        <div>Name:<span className="field-value"> {el.name}</span></div>
                        <div>Number of contents:<span className="field-value"> {el.content.length}</span></div>
                      </div> 
                    </div>
                  </div>
                </div>
              break;
          case (el.contentType=="highlighted" || el.activationEpoch!=null):
            return  <div key={index}>
                  <div key={index} className="box2 bcolor-grey ordered-list">
                    {getTopBottomIndex(index,el,arr)}
                    <div className="padding-10" style={{flex:1}}>
                      {getRowType("highlighted","Highlighted Content",el,arr)}
                      {getSingleTableValue(el,"highlighted")}</div>
                    
                  </div>
                </div>
              break;
          case (el.contentType=="staticImage"):
            return <div key={index}>
                  <div key={index} className="box2 bcolor-grey ordered-list">
                  {getTopBottomIndex(index,el,arr)}
                    <div style={{flex:1,alignSelf:'flex-start'}}> 
                      <div className="padding-10">
                        {getRowType("staticGraphic","Static Graphic",el,arr)}
                        <div className="staticGraphicPreviewBlock">
                          {el.url && 
                            <div><img style={{maxWidth:'100px',maxHeight:'100px'}} src={el.url} />
                            </div>
                          }
                          </div><div className="field-main"><div className="field-label">URL:</div><div className="field-value"> {el.url}</div></div>
                      </div>
                      
                    </div>
                  </div>
                </div>
          break;
          case (el.contentType=="room" || el.activationEpoch!=null):
            return  <div key={index}>
                  <div key={index} className="box2 bcolor-grey ordered-list">
                    {getTopBottomIndex(index,el,arr)}
                    <div className="padding-10" style={{flex:1}}>
                      {getRowType("room","Room Content",el,arr)}
                      {getSingleTableValue(el,"sportRoom")}</div>
                    
                  </div>
                </div>
              break;
        }
      })}
    </div>
    );
  }
  const handleUploadCompleted=(result)=>{
    const { uploadURL } = result.successful[0].response;
    const publicFolder = uploadURL.substr(uploadURL.lastIndexOf('/'));
    const extension = result.successful[0].extension;
    const publicFileUrl = `${process.env.REACT_APP_BACKEND_URL + process.env.REACT_APP_PUBLIC_UPLOADS + publicFolder + publicFolder}.${extension}`;
    if(publicFileUrl!=""){
        // console.log("store static graphic",publicFileUrl);
        setManualStaticGraphic(publicFileUrl); 
    }
    setTypeMode('2');
  }
  
  const insertImageElement=()=>{
    if(manualStaticGraphic){
      httpPost("downloadable",{"url":manualStaticGraphic}).then((res)=>{
        let obj={id:res.id,contentType:"staticImage",url:res.url};
        let newTableValues=popupValues.tableValue;
        if(newTableValues)
          newTableValues.splice(0, 0, obj);
        else{
          newTableValues=[];
          newTableValues.push(obj);
        }
        handlerOnChange({tableValue:newTableValues});
        setShowStaticImagePopup(false);
        removeImageElement();
      }).catch(error=>{
        console.log("error",error);
      });
    }else{
       httpPost("downloadable",{"url":backgroundGraphic}).then((res)=>{
        let obj={id:res.id,contentType:"backgroundImage",url:res.url};
        let newTableValues=popupValues.tableValue;
        if(newTableValues)
          newTableValues.splice(0, 0, obj);
        else{
          newTableValues=[];
          newTableValues.push(obj);
        }
        handlerOnChange({tableValue:newTableValues});
        setShowStaticImagePopup(false);
        removeImageElement();
      }).catch(error=>{
        console.log("error",error);
      });
    }
  }
  const removeImageElement=()=>{
    setManualStaticGraphic(null);
    setTypeMode('2');
    setEnableDragAndDrop(false);
    setTimeout(()=>{
      setEnableDragAndDrop(true);
    },500);
  }

  const handleOnChangeURL=(e)=>{
    setManualStaticGraphic(e.target.value);
  }
  const handleOnChangeURLbackground=(e)=>{
    setBackgroundImage(e.target.value);
  }

  return (
    <div className={"popup d-inline position-relative"+ (extraClassName?" "+extraClassName:"")}>
      <ModalBootstrap dialogClassName={"modal-"+field+(extraClassName?" "+extraClassName:"")} size={(!size?'xl':size)}
        show={show}
        onHide={handleClose}
        >
        <ModalBootstrap.Header closeButton>
          <ModalBootstrap.Title>
          <>
          {icon && <div className="modal-popup-inline"><div className="modal-popup-icon">{icon}</div></div>}
          <div className="modal-popup-inline">
          {superTitle && <><div>{superTitle}</div><div className="subTitle">{title}</div></>}
          {!superTitle && <div>{title}</div>}</div></>
          {/* title */}
          </ModalBootstrap.Title>
        </ModalBootstrap.Header>
        <ModalBootstrap.Body>
            {errors && Object.keys(errors).length > 0
          && (
            <Toaste type="error" mode="toast" data={errors} />
          )}
          {(viewSelectionType=="carousel" || viewSelectionType=="highlightedContent" || viewSelectionType=="spacesCarousel")  && <div><div className="current-space pad-left-15">Current Space: </div><div className="current-space-text">{spaceName}</div></div> }
          {viewSelectionType=="carousel" && <div className="box color-white">
            <div className="toggleGroup">
            <ButtonGroup className="toggle-button">
                {typeModes.map((mode, idx) => (
                  <ToggleButton
                    key={idx}
                    className={idx % 2 ? 'toggle-right' : 'toggle-left'}
                    id={`mode-${idx}`}
                    type="radio"
                    value={mode.value}
                    checked={typeMode === mode.value}
                    onChange={(e) => setTypeMode(e.currentTarget.value)}
                  >
                    {mode.name}
                </ToggleButton>
              ))}
            </ButtonGroup>
            </div>
          </div>}
          {typeMode=='1' && <Form>
            {configFile && configFile.map((formGroup,index)=>{
              return (
                <div key={index} className={viewSelection?"box color-white":""}>
                <FormGroup
                  key={index}
                  configFile={formGroup}
                  value={popupValues}
                  onChange={handlerOnChange}
                  params={mode}
                  parentData={parentData}
                />
                </div>
              );
            })}
          </Form>}
          {typeMode=='2' &&  
            <div className="box color-white">
              <div className="staticGraphic">
                <Form>
                  {enableDragAndDrop && <UploadDragAndDrop
                    aspectRatio={''}
                    onCompleted={handleUploadCompleted}
                    fileType={['image/*']}
                  />}
                  {manualStaticGraphic && <div className="staticGraphicPos"><img className="staticGraphicPreview" src={manualStaticGraphic} /></div>} 
                  <div className="staticGraphicInput">
                    <FormInputText
                      type={FormInputTypes.TEXT_INPUT.URL}
                      helpText="Resource URL"
                      label="URL"
                      name="url"
                      id={"staticGraphicId"}
                      onChange={handleOnChangeURL}
                      value={manualStaticGraphic}
                    /> 
                  </div>
                  <Button
                    id={"Insert"}
                    className="float-right"
                    type={"button"}
                    onClick={() => insertImageElement()}
                    theme={ButtonTheme.PRIMARY}
                    title="Move element up"
                  >Insert Static Graphic
                  </Button>
                  <Button
                    id={"Cancel"}
                    className="float-right"
                    type={"button"}
                    onClick={() => removeImageElement()}
                    theme={ButtonTheme.SECONDARY}
                    icon={IconType.CLOSE}
                    title="Cancel"
                  >
                  </Button>
                </Form>
              </div>
            </div>
            }
          {viewSelection && <div className="box color-white">
            <div className="itemSelectedTitle">
              
              <div className="items-selected">Selected {superTitle=="Carousel"?"Carousel Videos":superTitle}</div>
              
              {spaceName && <div><div className="current-space">Current Space: </div><div className="current-space-text">{spaceName}</div></div>}
            </div>
            {popupValues && popupValues.tableValue && Array.isArray(popupValues.tableValue) && <div className="box">{getArrayTableValues(popupValues.tableValue)}</div>}
            {popupValues && popupValues.tableValue && !Array.isArray(popupValues.tableValue) && <div className="box bcolor-grey">
              {popupValues.type=="sportRoom" && getRowType("SportRoom","Room Content",null,null)}
              {popupValues.type=="highlightedContent" && getRowType("highlighted","Highlighted Content",null,null)}
              {popupValues && popupValues.tableValue && popupValues.type && getSingleTableValue(popupValues.tableValue,popupValues.type)}
            </div>}
            {popupValues && (!popupValues.tableValue || popupValues.tableValue.length==0)&& !popupValues.allCategories && <div className="box bcolor-grey min-height-100-and-center">
              <div className="color-grey">
              You have not chosen any {superTitle} yet
              </div>
            </div>}
            {/* only for content categories object allCategories */}
            {popupValues.allCategories && <div className="box bcolor-grey text-center"><div>
              All {superTitle} selected
            </div></div>}
          </div>}
        </ModalBootstrap.Body>
        <ModalBootstrap.Footer>
          <FormPopupFooter id={id} mode={mode} onClose={handleClose} onEdit={handleEdit} onSave={handleSave} onSecondary={handleEdit}/>
        </ModalBootstrap.Footer>
      </ModalBootstrap>

      {/* FOR ADDING STATIC IMAGE */}
      <ModalBootstrap dialogClassName={"modal-"+field+(extraClassName?" "+extraClassName:"")} size={'lg'}
        show={showStaticImagePopup}
        onHide={handleCloseStaticImage}
        >
        <ModalBootstrap.Header closeButton>
          <ModalBootstrap.Title>
          <>
          {staticImageTitle}</>
          {/* title */}
          </ModalBootstrap.Title>
        </ModalBootstrap.Header>
        <ModalBootstrap.Body>
        <Form>
            {staticImageConfig && staticImageConfig.map((formGroup,index)=>{
              return (
                <div key={index} className={viewSelection?"box color-white":""}>
                <FormGroup
                  key={index}
                  configFile={formGroup}
                  value={popupValuesStaticImage}
                  onChange={handlerOnChangeStaticImage}
                  params={mode}
                  parentData={parentData}
                />
                </div>
              );
            })}
          </Form>
        </ModalBootstrap.Body>
        <ModalBootstrap.Footer>
          <FormPopupFooter id={id} mode={mode} onClose={handleCloseStaticImage} onEdit={handleEditStaticImage} onSave={handleSaveStaticImage} onSecondary={handleEditStaticImage}/>
        </ModalBootstrap.Footer>
      </ModalBootstrap>
    </div>
  );
};

FormPopup.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.bool,
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  type: PropTypes.oneOf(Object.values(ButtonType)),
  /**
   * Button background color
   */
  theme: PropTypes.oneOf(Object.values(ButtonTheme)),
  /**
   * Button general size
   */
  size: PropTypes.oneOf(Object.values(ModalSize)),
};

FormPopup.defaultProps = {
  onChange: () => {},
  value: {},
  id: -1,
  type: null,
  viewSelection:false
};

export default FormPopup;
